import type React from "react";

export enum ShortlistType {
  ALL_HEARTS = "ALL_HEARTS",
  HEARTS = "HEARTS",
  HEARTS_ON_SALE = "HEARTS_ON_SALE",
  SHORTLIST = "SHORTLIST",
  DOWN_VOTES = "DOWN_VOTES",
}

export interface Shortlist {
  shortlistId: string;
  userId: number;
  name: string;
  type: ShortlistType;
  createdAt?: Date;
  modifiedAt?: Date;
  size: number;
  previewImages: string[];
  isUserGenerated: boolean;
}

export interface FavoritesHomeProps {
  shortlistSummary?: Shortlist[];
}

export interface ShortlistCardProps {
  shortlist: Shortlist;
  onDeleteSuccess?: () => void;
}

export interface ShortlistProps {
  addStyleToShortlist: (
    shortlistId: string,
    styleName: string,
    onSuccess?: (() => void) | null,
    onFailure?: () => void
  ) => void;
  onClickFavoriteShortlist: () => void;
  productId?: string;
  removeStyleFromShortlist: (
    shortlistId: string,
    styleName: string,
    onSuccess?: (() => void) | null,
    onFailure?: () => void
  ) => void;
  shortlist: Shortlist;
  styleNames: string[];
}

export interface ShortlistListProps {
  addStyleToShortlist: (
    shortlistId: string,
    styleName: string,
    onSuccess?: (() => void) | null,
    onFailure?: () => void
  ) => void;
  fetchShortlists: () => void;
  onClose: () => void;
  productId: string;
  removeProductRating: (styleName: string) => void;
  removeStyleFromShortlist: (
    shortlistId: string,
    styleName: string,
    onSuccess?: (() => void) | null,
    onFailure?: () => void
  ) => void;
  isMobileViewport?: boolean;
  product?: Record<string, unknown>;
  isOpen: boolean;
}

export interface ShortlistImagesProps {
  images?: string[] | null;
}

export interface ShortlistFormProps {
  fetchShortlists?: () => void;
  hideShortlistCreateForm: (event?: React.MouseEvent) => void;
  product?: Record<string, unknown>;
  productId?: string;
  toggleForm?: () => void;
  isMobileViewport?: boolean;
  isFavoritesPage?: boolean;
}

export interface ShortlistDeleteProps {
  shortlistId: string;
  shortlistName: string;
  isOpen: boolean;
  onDeleteSuccess: () => void;
  onRequestClose?: () => void;
}
